<script>

import ArrowBackIcon from "@/components/Common/Icons/ArrowBackIcon.vue";

export default {
  name: 'DropDown',
  components: {ArrowBackIcon,},
  props: {
    type: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    selectedProp: {
      type: [Number, String],
      default: null
    },
    error: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    handleChange(e) {
      this.$emit('update:modelValue', e.target.value);
    },
  },
}
</script>

<template>
  <div :class="{
    'dropdown': true,
    'right-inner-addon': true,
    'dropdown-size-large': size === 'large',
    'error': error,
  }">
    <select class="input" @change="handleChange">
      <option :selected="selectedProp === null" :value="null" disabled>{{ label }}</option>
      <option v-for="(value, key) in options" :key="key" :selected="key == selectedProp" :value="key">
        {{ $t(value.length > 0 ? value : 'value') }}
      </option>
    </select>
    <div class="arrow-down-icon">
      <ArrowBackIcon/>
    </div>

  </div>
</template>

<style lang="scss" scoped>
.dropdown {
  position: relative;
  cursor: pointer;
}

select {
  -moz-appearance: none;
  -webkit-appearance: none;
  background: $color-white;
  color: $color-brown;
  border: none;
  border-radius: 30px;
  padding: 15px 20px;
  width: 100%;
  cursor: pointer;
}

.input:hover {
  border: none;
}

.input:active {
  border: none;
}

.input:focus {
  outline: none;
}

.arrow-down-icon {
  position: absolute;
  right: 5%;
  top: 30%;
  transform: rotate(270deg) scale(0.5);
}
</style>
